import { motion } from 'motion/react';

interface PageLayoutProps {
  children?: React.ReactNode;
  darken?: number;
}

export function PageLayout({ children, darken = 0 }: PageLayoutProps) {
  return (
    <motion.div
      className="relative min-h-screen text-foreground overflow-hidden"
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.98 }}
      transition={{ duration: 0.3, ease: 'easeInOut' }}
    >
      <div
        className="absolute inset-0 z-0"
        style={{
          background:
            'linear-gradient(135deg, var(--gradient-from) 0%, var(--gradient-via) 50%, var(--gradient-to) 100%)',
          filter: darken > 0 ? `brightness(${1 - darken})` : undefined,
        }}
      />
      <div className="relative z-10">{children}</div>
    </motion.div>
  );
}
